'use client';

import { useState } from 'react';
import styles from './ui.module.css';
import { Icon } from './Icon';
import type { FaqItem } from '@/content/faq';

/** Lista de perguntas em acordeão; a primeira começa aberta, como no canvas. */
export function Faq({
  items,
  idPrefix,
}: {
  items: FaqItem[];
  idPrefix: string;
}) {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <div className={styles.faq} data-reveal=''>
      {items.map((item, i) => {
        const isOpen = open === i;
        const answerId = `${idPrefix}-${i}`;
        return (
          <div
            key={item.question}
            className={`${styles.faqItem} ${isOpen ? styles.faqOpen : ''}`}
          >
            <h3 style={{ margin: 0 }}>
              <button
                type='button'
                className={styles.faqButton}
                aria-expanded={isOpen}
                aria-controls={answerId}
                onClick={() => setOpen(isOpen ? null : i)}
              >
                <span className={styles.faqIcon}>
                  <Icon
                    name={isOpen ? 'minus' : 'plus'}
                    size={14}
                    strokeWidth={2.4}
                  />
                </span>
                {item.question}
              </button>
            </h3>
            <div
              id={answerId}
              className={styles.faqAnswer}
              role='region'
              aria-hidden={!isOpen}
            >
              <div>
                <p>{item.answer}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
